import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import Directory from "../../../../services/Directory";
import CustomInput from "../../../custom/custom-input/CustomInput";
import CustomButton from "../../../custom/custom-button/CustomButton";
import CloseIconNew from "../../../shared/icons/CloseIconNew";
import style from "./AddCategoryModal.module.scss";

const AddCategoryModal = ({ onClose, onCategoryAdded, initialName = "" }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(initialName);
  const [errorTitle, setErrorTitle] = useState("");
  const [successView, setSuccessView] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    if (!name.trim()) {
      setErrorTitle("Необходимо заполнить название категории");
      return;
    }

    setErrorTitle("");
    setIsSubmitting(true);
    try {
      const response = await Directory.addPrivateCategory({ name: name.trim() });
      if (response.status === 200 || response.status === 201) {
        setSuccessView(true);
        if (onCategoryAdded) onCategoryAdded(response.data);
      } else {
        setErrorTitle("Произошла ошибка, попробуйте позже");
      }
    } catch (error) {
      console.log(error);
      setErrorTitle("Произошла ошибка, попробуйте позже");
    } finally {
      setIsSubmitting(false);
    }
  };

  return ReactDOM.createPortal(
    <div className={style.modalOverlay} data-portal-modal="true">
      <div className={style.modalContainer}>
        <div className={style.topbar}>
          <h2 className={style.modalTitle}>{t("bulkCreate.fields.addCategory")}</h2>
          <button
            type="button"
            className={style.closeBtn}
            onClick={onClose}
            aria-label={t('bulkCreate.publish.close')}
          >
            <CloseIconNew />
          </button>
        </div>

        {successView ? (
          <div className={style.successCard}>
            <div className={style.successIconWrap}>
              <img src="/icons/tick-success.svg" height="22px" alt="Success" />
            </div>
            <div className={style.successTitle}>Категория успешно добавлена!</div>
            <div className={style.successSubtitle}>
              Теперь данная категория доступна при создании заказа
            </div>
            <div className={style.modalActions}>
              <CustomButton isNavy text="Закрыть" onClick={onClose} />
            </div>
          </div>
        ) : (
          <>
            <div className={style.card}>
              <CustomInput
                labelText="Название категории"
                placeholder="Введите название категории"
                isBgGray
                errorText={errorTitle}
                inputType="text"
                value={name}
                onChangeValue={(item) => {
                  setName(item);
                  if (item) setErrorTitle("");
                }}
              />
            </div>

            <div className={style.modalActions}>
              <CustomButton
                isCancel
                text={t('bulkCreate.publish.cancel')}
                onClick={onClose}
                disabled={isSubmitting}
              />
              <CustomButton
                isNavy
                text={t("orderInfoExpeditor.expectedArrival.add")}
                onClick={onSubmit}
                isLoading={isSubmitting}
                disabled={isSubmitting || !name.trim()}
              />
            </div>
          </>
        )}
      </div>
    </div>,
    document.body,
  );
};

export default AddCategoryModal;
